import styled from 'styled-components';

// 히트펌프 대시보드 공통 패널 스타일
export const Panel = styled.article`
  min-width: 0;
  padding: 22px;
  background: linear-gradient(150deg, #131f31, #0f1929);
  border: 1px solid #243249;
  border-radius: 16px;
  box-shadow: 0 12px 28px #0002;

  @media (max-width: 750px) {
    padding: 15px 13px;
  }
`;

export const PanelTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 17px;

  h2 {
    font-size: 16px;
    font-weight: 700;
    margin: 0;
    color: #edf3fc;
  }
  > span {
    font-size: 11px;
    color: #879db8;
  }

  @media (max-width: 700px) {
    flex-wrap: wrap;
    h2 {
      font-size: 15px;
    }
  }
`;

export const BarTrack = styled.div`
  height: ${(props) => props.height || 8}px;
  border-radius: 9px;
  background: #1f3047;
  overflow: hidden;
`;

export const BarFill = styled.div`
  height: 100%;
  border-radius: 9px;
  background: ${(props) => props.background || 'linear-gradient(90deg, #368fff, #65c9ff)'};
  transition: width 0.4s;
`;

export const Chip = styled.span`
  font-size: 11px;
  color: #9fb9d2;
  border: 1px solid #34465e;
  border-radius: 25px;
  padding: 7px 11px;
  max-width: 100%;
  overflow-wrap: anywhere;
`;
